"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SelectDeselectMenuList = exports.OnlySelectAllMenuList = exports.HiddenDropdownSeparator = exports.HiddenDropdownIndicator = exports.DefaultOptionComponent = exports.DefaultLoaderComponent = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _differenceWith = _interopRequireDefault(require("lodash-es/differenceWith"));

var _isEqual = _interopRequireDefault(require("lodash-es/isEqual"));

var _reactSelect = require("react-select");

var _utils = require("../lib/utils");

var _bouncer = _interopRequireDefault(require("../bouncer/bouncer"));

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _button = _interopRequireDefault(require("../button/button"));

var _label = _interopRequireDefault(require("../label/label"));

/* eslint-disable react/prop-types */

/* eslint-disable react/jsx-fragments */
var DefaultLoaderComponent = function DefaultLoaderComponent() {
  return /*#__PURE__*/_react["default"].createElement(_bouncer["default"], null);
};

exports.DefaultLoaderComponent = DefaultLoaderComponent;

var DefaultOptionComponent = function DefaultOptionComponent(optionProps) {
  var _optionProps$data$too = optionProps.data.tooltip,
      tooltip = _optionProps$data$too === void 0 ? {} : _optionProps$data$too;
  var text = tooltip.text;
  var tooltipContent = (0, _utils.isFunction)(text) ? text(optionProps.data) : text;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, optionProps, tooltipContent ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], (0, _extends2["default"])({}, tooltip, {
    text: tooltipContent
  }), /*#__PURE__*/_react["default"].createElement("span", null, optionProps.data.label)) : optionProps.data.label);
};

exports.DefaultOptionComponent = DefaultOptionComponent;

var SelectDeselectMenuList = function SelectDeselectMenuList(props) {
  var selectProps = props.selectProps,
      _props$options = props.options,
      allOptions = _props$options === void 0 ? [] : _props$options,
      children = props.children;
  var _selectProps$userProp = selectProps.userProps,
      onChange = _selectProps$userProp.onChange,
      validationProps = _selectProps$userProp.validationProps,
      fieldName = _selectProps$userProp.name;
  var enabledOptions = (0, _filter["default"])(allOptions).call(allOptions, function (opt) {
    return !opt.isDisabled;
  });
  var totalOptions = allOptions.length;
  var selectedOptions = selectProps.value || [];
  var difference = (0, _differenceWith["default"])(allOptions, selectedOptions, _isEqual["default"]);
  var isAllSelected = (0, _differenceWith["default"])(enabledOptions, selectedOptions, _isEqual["default"]).length === 0;
  var totalSelected = Math.max(allOptions.length - difference.length, 0);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MenuList, props, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-select-footer-container oui-select-deselect-all-footer"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: "oui-select-footer-button-link",
    type: "link",
    disabled: allOptions.length === 0,
    label: !isAllSelected || allOptions.length === 0 ? "Select All" : "Deselect All",
    onClick: function onClick() {
      var selectVals = [];

      if (isAllSelected) {
        var _context;

        selectVals = (0, _filter["default"])(_context = (0, _differenceWith["default"])(selectedOptions, allOptions, _isEqual["default"])).call(_context, function (option) {
          return !option.isDisabled;
        });
      } else {
        var _context2, _context3;

        selectVals = (0, _filter["default"])(_context2 = (0, _concat["default"])(_context3 = []).call(_context3, (0, _toConsumableArray2["default"])(selectedOptions), (0, _toConsumableArray2["default"])(difference))).call(_context2, function (option) {
          return !option.isDisabled;
        });
      }

      onChange(selectVals);

      if (validationProps && validationProps.setFieldValue && fieldName) {
        validationProps.setFieldValue(fieldName, selectVals, true);
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-d-flex oui-align-items-center oui-footer-subtext"
  }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
    className: "oui-m-0",
    text: "".concat(totalOptions, " found")
  }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
    className: "oui-m-0 oui-ml-3 oui-footer-subtext",
    text: "".concat(totalSelected, " selected")
  }))));
};

exports.SelectDeselectMenuList = SelectDeselectMenuList;

var OnlySelectAllMenuList = function OnlySelectAllMenuList(props) {
  var selectProps = props.selectProps,
      children = props.children;
  var internalRef = selectProps.internalRef,
      _selectProps$userProp2 = selectProps.userProps,
      selectAllButtonText = _selectProps$userProp2.selectAllButtonText,
      selectAllOptionDisabled = _selectProps$userProp2.selectAllOptionDisabled,
      selectAllOptionDisabledTooltip = _selectProps$userProp2.selectAllOptionDisabledTooltip,
      selectAllOption = _selectProps$userProp2.selectAllOption,
      footerRenderer = _selectProps$userProp2.footerRenderer,
      onChange = _selectProps$userProp2.onChange,
      validationProps = _selectProps$userProp2.validationProps,
      fieldName = _selectProps$userProp2.name,
      isMulti = _selectProps$userProp2.isMulti;
  var selectAllText = selectAllButtonText || "Select All";
  var isFooterRequired = (0, _utils.isFunction)(footerRenderer);
  var isSelectAllRequired = (0, _utils.isObject)(selectAllOption) && selectAllOption.label && selectAllOption.value && isMulti === true;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MenuList, props, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-select-footer-container ".concat(!isFooterRequired && isSelectAllRequired ? "oui-select-only-generic-all" : "")
  }, isFooterRequired ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-select-custom-footer"
  }, footerRenderer()) : null, isSelectAllRequired ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-select-generic-all-link"
  }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: selectAllOptionDisabledTooltip,
    showToolTip: selectAllOptionDisabled === true && (0, _utils.isString)(selectAllOptionDisabledTooltip)
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: "oui-select-footer-button-link",
    disabled: selectAllOptionDisabled,
    type: "link",
    label: selectAllText,
    onClick: function onClick() {
      onChange([selectAllOption]);

      if (internalRef.current) {
        // Need to focus again to maintain user experience
        internalRef.current.blur();
        internalRef.current.focus();
      }

      if (validationProps && validationProps.setFieldValue && fieldName) {
        validationProps.setFieldValue(fieldName, [selectAllOption], true);
      }
    }
  })))) : null));
};

exports.OnlySelectAllMenuList = OnlySelectAllMenuList;

var HiddenDropdownIndicator = function HiddenDropdownIndicator() {
  return null;
};

exports.HiddenDropdownIndicator = HiddenDropdownIndicator;

var HiddenDropdownSeparator = function HiddenDropdownSeparator() {
  return null;
};

exports.HiddenDropdownSeparator = HiddenDropdownSeparator;